import { FC } from 'react';
import { Link } from "react-router-dom";
import "./Logo.scss"

interface LogoBoxProps {
    stopRedirect?: boolean;
}

const LogoBox: FC<LogoBoxProps> = ({stopRedirect = false}) => {

    return (
        <Link
            className='logo'
            to={stopRedirect ? "#" : "/landing/charts"}
        >
            <div className='logo'>
                <h1 className='logo__title'>ECOMRU.RU</h1>
            </div>
        </Link>

    )
}

export { LogoBox }